var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "ma-2", attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { staticClass: "pt-0" },
        [
          _c(
            "v-layout",
            { staticClass: "mt-3", attrs: { "align-center": "" } },
            [
              _c(
                "v-flex",
                [
                  _c(
                    "v-layout",
                    { attrs: { "align-center": "" } },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-2", attrs: { color: "primary" } },
                        [_vm._v("battery_charging_full")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "subheading" }, [
                        _vm._v(_vm._s(_vm.$t("lithiumBattery")))
                      ]),
                      _vm._v(" "),
                      _vm.props.item.lithiumBatteryOptions &&
                      _vm.props.item.lithiumBatteryOptions.length > 0
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "ml-3",
                              attrs: {
                                small: "",
                                color: "primary",
                                "text-color": "white"
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.props.item.lithiumBatteryOptions.length
                                  ) +
                                  " " +
                                  _vm._s(_vm.$t("selected")) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "", "max-width": "400" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "v-icon",
                                    _vm._g(
                                      {
                                        staticClass: "ml-2",
                                        attrs: { color: "primary" }
                                      },
                                      on
                                    ),
                                    [_vm._v("help")]
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("lithiumBatteriesHelp")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            small: "",
                            dark: "",
                            flat: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.applyAll(_vm.props.item)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("applyToAll")) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "ml-4 mt-3", attrs: { column: "" } },
            _vm._l(_vm.lithiumBatteryOptionItems, function(option) {
              return _c(
                "v-flex",
                { key: option.value },
                [
                  _c(
                    "v-flex",
                    { attrs: { md4: "", xs5: "", xl3: "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { "align-center": "" } },
                        [
                          _c("v-checkbox", {
                            staticClass: "mt-0 mb-1",
                            attrs: {
                              label: option.label,
                              value: option.value,
                              "hide-details": "",
                              dense: ""
                            },
                            model: {
                              value: _vm.props.item.lithiumBatteryOptions,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.props.item,
                                  "lithiumBatteryOptions",
                                  $$v
                                )
                              },
                              expression: "props.item.lithiumBatteryOptions"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "", "max-width": "300" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              attrs: {
                                                color: "primary",
                                                small: ""
                                              }
                                            },
                                            on
                                          ),
                                          [_vm._v("help")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(option.tooltip))])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7899b1b9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7899b1b9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LithiumBatteryDangerousGoods.vue
// module id = null
// module chunks = 